import { array, struct } from 'io-ts/lib/Decoder';

import { EqualsType } from '../../api/generic/search/filter';
import { Id as ClientTypeId } from '../../client/client-type';

export const ClientType = struct({
	equalsType: EqualsType,
	values: array(ClientTypeId),
});
